import React, { useState, useEffect } from "react";
import { Box, useTheme, InputBase, IconButton } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SearchIcon from "@mui/icons-material/Search";
import { getOneProductoDeposito, getProductoAmoxarifado } from "../../services/amoxarifado.services";
import ModalImage from "../../modal/imagen/modalImagen";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import { getApiImagen } from "../../utils/getApiBaseUrl";


const ProductosViewAmoxarifado = () => {
  const [data, setData] = useState([]); 
  const [selectedImage, setSelectedImage] = useState(null); 
  const [searchValue, setSearchValue] = useState(""); // Valor del campo de búsqueda
  const [filteredData, setFilteredData] = useState([]); // Datos filtrados para la tabla
  const [selectedRow, setSelectedRow] = useState(null);
  const [errorMessage, setErrorMessage] = useState(''); 
  const [printerInfo, setPrinterInfo] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Definir columnas de la tabla
  const columns = [
    {
          field: "menu",
          headerName: "",
          flex: 0.2,
          renderCell: (params) => (
            <IconButton onClick={(event) => handleMenuClick(event, params.row)}>
              <MenuIcon />
            </IconButton>
          ),
    },
    { field: "id", headerName: "ID", flex: 0.1 },
    {
      field: "producto",
      headerName: "Marca",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "subcategoria",
      headerName: "Subcategoría",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "cod",
      headerName: "Código",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "serie",
      headerName: "serie",
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
        field: "imagen",
        headerName: "Imagen",
        flex: 1,
        headerAlign: "left",
        align: "left",
        renderCell: (params) => (
            <img 
                src={`${getApiImagen()}${params.value}`} 
                alt="Producto" 
                style={{ width: "100px", height: "100px", objectFit: "cover" }} 
                onClick={() => handleImageClick(`${getApiImagen()}${params.value}`)}
            />
        ),
    }
  ];
    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const handleCloseImageModal = () => {
        setSelectedImage(null);
    };


  useEffect(() => {
    const fetchProducto = async () => {
      try {
        const response = await getProductoAmoxarifado();
        // console.log(response);
        setData(response);
        setFilteredData(response);
      } catch (error) {
        console.error("Error al obtener los grupos del backend:", error);
      }
    };

    fetchProducto(); // Llamar a la función que obtiene los grupos
  }, []);

  const handlePrint5cm = async () => {
      if (!selectedRow || !selectedRow.id) {
        setErrorMessage('No se ha seleccionado ninguna fila.');
        return;
      }
      const { id, serie } = selectedRow;
      try {
        const response = await getOneProductoDeposito(serie);
        // console.log("🚀 ~ handlePrint5cm ~ response:", response)
      const items = Array.isArray(response) ? response : [response];
      const etiquetas = await Promise.all(items.map(async (item) => {
      const fecha = new Date(item.create_at).toLocaleDateString("es-ES");
      let zpl = ""; // Aquí seleccionamos el ZPL según el cliente
  
        zpl = `^XA
  
  ^PON
  ^PW800
  ^LL400
  
  ^FO20,220^A0N,50,40^FD${response.cod}^FS
  
  
  ^FO20,10^BQN,2,6^FDQA,${response.serie}^FS
  
  ^XZ
  
  `;
          ;
    
          return zpl;
    
        }));
        if (window.BrowserPrint) { // Asegúrate de que BrowserPrint está disponible
          window.BrowserPrint.getDefaultDevice("printer",
            (device) => {
              if (device) {
                setPrinterInfo(`Dispositivo predeterminado encontrado: ${device.name}`);
                let zplCommand = etiquetas.join("\n");
    
                device.send(zplCommand, function(response) {
                  // console.log("Datos enviados exitosamente:", response);
                }, function(error) {
                  console.error("Error al enviar datos:", error);
                });
              } else {
                setPrinterInfo("No hay una impresora predeterminada configurada.");
              }
            },
            (error) => {
              setErrorMessage(`Error al obtener el dispositivo predeterminado: ${error}`);
            }
          );
        } else {
          setErrorMessage('BrowserPrint no está disponible.');
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        setErrorMessage('Error al obtener los datos.');
      }
    
      handleMenuClose();
    };

  // Manejar la búsqueda en la tabla
  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
    const filtered = data.filter((item) =>
      item.producto.toLowerCase().includes(value.toLowerCase()) 
      );
    
    setFilteredData(filtered);
  };

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };



  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" p={0}>
        <Header title="Productos" subtitle="Lista de Productos" />
        <Box display="flex" alignItems="center">
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            height={"40%"}
            width={"90%"}
            ml={1}
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Buscar"
              value={searchValue}
              onChange={handleSearchChange}
            />
            <IconButton type="button" sx={{ p: 1 }}>
              <SearchIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={filteredData}
          getRowId={(row) => row.id} // Acceder correctamente al campo `Id`
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          disableMultipleSelection={true}
        />
        <ModalImage
                open={Boolean(selectedImage)}
                onClose={handleCloseImageModal}
                imageSrc={selectedImage}
        />
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handlePrint5cm}>Imprimir Etiqueta</MenuItem>
        </Menu>
       
      </Box>
    </Box>
  );
};

export default ProductosViewAmoxarifado;